export const pointOfSaleEsLocale = {
  'checkout.pointOfSale.title': 'Pago en Punto de Venta',
  'checkout.pointOfSale.taquilla': 'Pago en taquilla',
  'checkout.pointOfSale.cashValue': 'Valor en efectivo',
  'checkout.pointOfSale.cardValue': 'Valor con tarjeta',
  'checkout.pointOfSale.phone': 'Teléfono',
  'checkout.pointOfSale.name': 'Nombre',
  'checkout.pointOfSale.lastName': 'Apellido',
  'checkout.pointOfSale.email': 'Correo electrónico',
  'checkout.pointOfSale.passport': 'Pasaporte',
  'checkout.pointOfSale.identityDocument': 'Documento de identidad',
  'checkout.pointOfSale.cashToReceive': 'Efectivo a recibir',
  'checkout.pointOfSale.change': 'Cambio a entregar',
  'checkout.pointOfSale.print': 'Imprimir ticket',

  'checkout.pointOfSale.cashError': 'Ingresa el valor en efectivo',
  'checkout.pointOfSale.cardError': 'Ingresa el valor con tarjeta',
  'checkout.pointOfSale.phoneError': 'Ingresa el teléfono',
  'checkout.pointOfSale.nameError': 'Ingresa el nombre',
  'checkout.pointOfSale.lastNameError': 'Ingresa el apellido',
  'checkout.pointOfSale.emailError': 'Ingresa el correo electrónico',
  'checkout.pointOfSale.identityError': 'Ingresa el documento de identidad',
  'checkout.pointOfSale.cashToReceiveError':
    'El valor es menor al pago en efectivo establecido',

  'checkout.pointOfSale.charge': 'Cobrar',
  'checkout.pointOfSale.continue': 'Continuar',
  'checkout.pointOfSale.procesing': 'Procesando...',

  'checkout.pointOfSale.buy': 'Compra',
  'checkout.pointOfSale.success':
    'El pago ha sido realizado con éxito, gracias por su compra',
} as const;

export const pointOfSaleEnLocale = {
  'checkout.pointOfSale.title': 'Payment at Point of Sale',
  'checkout.pointOfSale.taquilla': 'Payment at box office',
  'checkout.pointOfSale.cashValue': 'Cash value',
  'checkout.pointOfSale.cardValue': 'Card value',
  'checkout.pointOfSale.phone': 'Phone',
  'checkout.pointOfSale.name': 'Name',
  'checkout.pointOfSale.lastName': 'Last name',
  'checkout.pointOfSale.email': 'Email',
  'checkout.pointOfSale.passport': 'Passport',
  'checkout.pointOfSale.identityDocument': 'Identity document',
  'checkout.pointOfSale.cashToReceive': 'Cash to receive',
  'checkout.pointOfSale.change': 'Change to deliver',
  'checkout.pointOfSale.print': 'Print ticket',

  'checkout.pointOfSale.cashError': 'Enter the cash value',
  'checkout.pointOfSale.cardError': 'Enter the card value',
  'checkout.pointOfSale.phoneError': 'Enter the phone',
  'checkout.pointOfSale.nameError': 'Enter the name',
  'checkout.pointOfSale.lastNameError': 'Enter the last name',
  'checkout.pointOfSale.emailError': 'Enter the email',
  'checkout.pointOfSale.identityError': 'Enter the identity document',
  'checkout.pointOfSale.cashToReceiveError':
    'The value is less than the established cash payment',

  'checkout.pointOfSale.charge': 'Charge',
  'checkout.pointOfSale.continue': 'Continue',
  'checkout.pointOfSale.procesing': 'Processing...',

  'checkout.pointOfSale.buy': 'Buy',
  'checkout.pointOfSale.success':
    'The payment has been made successfully, thank you for your purchase',
} as const;
